(() => {
  if (window.pusunAccessoriesDisplayLoaded) return;
  window.pusunAccessoriesDisplayLoaded = true;
  function describe(value) {
    const text = value.toLowerCase();
    if (text === 'external battery') return ['1 × External Battery', 'Power your machine with a compatible external battery.'];
    if (text === 'battery charger') return ['1 × Battery Charger', 'Recharge the compatible battery.'];
    if (text === 'remote control') return ['1 × Remote Control', 'Control your compatible machine remotely.'];
    if (text === 'ac power adapter') return ['1 × AC Power Adapter', 'Power your compatible machine from a wall outlet.'];
    if (/cables.*2\s*pcs/.test(text)) return ['2 × Battery Connection Cables', 'Connect the compatible external battery to your machine.'];
    if (!/^battery\s*\+/.test(text)) return null;
    const items = ['1 × External Battery'];
    if (text.includes('cable')) items.push('1 × Battery Connection Cable');
    if (text.includes('charger')) items.push('1 × Battery Charger');
    if (text.includes('remote')) items.push('1 × Remote Control');
    return [items.join(', '), text.includes('charger') ? 'Power your machine with an external battery and recharge the battery when needed.' : 'Power your machine with a compatible external battery.'];
  }
  function refresh() {
    document.querySelectorAll('[data-pusun-selection]').forEach(card => {
      const details = card.closest('.product-details');
      const picker = details?.querySelector('variant-picker');
      if (!picker || typeof picker.getAllSelectedOptions !== 'function') return;
      const options = picker.getAllSelectedOptions();
      const model = options.find(o => o.name === card.dataset.modelName)?.value;
      const pack = options.find(o => o.name === card.dataset.packageName)?.value;
      const description = pack && describe(pack);
      if (!model || !description) {card.hidden = true; return;}
      const texts = [[ '[data-pusun-model]', model ], ['[data-pusun-includes]',description[0]], ['[data-pusun-use]',description[1]]];
      texts.forEach(([selector, value]) => { const node=card.querySelector(selector); if(node.textContent !== value) node.textContent=value; });
      // Keep native buy controls intact; insert the card immediately after the picker.
      if (picker.nextElementSibling !== card) picker.after(card);
      card.hidden = false;
    });
  }
  let queued = false;
  const schedule = () => {if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;refresh();});};
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', event => {
    const thumb=event.target.closest?.('.slideshow-controls__thumbnail');
    const gallery=thumb?.closest('[data-pusun-accessories-gallery]');
    if(!gallery || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)return;
    const controls=thumb.closest('slideshow-controls');
    const index=Array.from(controls.querySelectorAll('.slideshow-controls__thumbnail')).indexOf(thumb);
    let data;try{data=JSON.parse(gallery.querySelector('[data-pusun-gallery-links]').textContent);}catch{return;}
    const urls=data.complete && data.media[index]?.urls;
    // Unbound or ambiguous photos remain native previews.
    if(!urls || urls.length!==1)return;
    const url=new URL(urls[0],location.origin);
    if(url.origin!==location.origin)return;
    const current=new URL(location.href);
    if(current.searchParams.get('variant')===url.searchParams.get('variant'))return;
    event.preventDefault();event.stopImmediatePropagation();
    location.assign(url.href);
  },true);
  const observer=new MutationObserver(schedule);
  function start(){document.querySelectorAll('.product-details:has([data-pusun-selection])').forEach(el=>observer.observe(el,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','selected']}));schedule();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
